module.exports = __webpack_public_path__ + "static/media/zip.7580555b.svg";